import { useEffect } from "react";

export const SITE_NAME = "Hair Elixir Hungary";
export const DEFAULT_IMAGE = "/logo-full.png";

const absUrl = (u) => (!u ? u : u.startsWith("http") ? u : window.location.origin + u);

function setTag(selector, create, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(create);
    el.setAttribute("data-seo", "");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
}

const meta = (key, value, attr = "name") =>
  setTag(`meta[${attr}="${key}"]`, "meta", { [attr]: key, content: value });

export function useSeo({ title, description, path, image, type = "website", noindex = false, jsonLd, keywords }) {
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    if (!title) return;
    const url = window.location.origin + (path ?? window.location.pathname);
    const img = absUrl(image || DEFAULT_IMAGE);
    document.title = title;
    meta("description", description || "");
    meta("robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large");
    if (keywords) meta("keywords", keywords);
    setTag('link[rel="canonical"]', "link", { rel: "canonical", href: url });
    meta("og:title", title, "property");
    meta("og:description", description || "", "property");
    meta("og:url", url, "property");
    meta("og:type", type, "property");
    meta("og:image", img, "property");
    meta("og:site_name", SITE_NAME, "property");
    meta("og:locale", "hu_HU", "property");
    meta("twitter:card", "summary_large_image");
    meta("twitter:title", title);
    meta("twitter:description", description || "");
    meta("twitter:image", img);

    let script = document.getElementById("seo-jsonld");
    if (ld) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "seo-jsonld";
        document.head.appendChild(script);
      }
      script.textContent = ld;
    } else if (script) {
      script.remove();
    }
    return () => {
      const kw = document.head.querySelector('meta[name="keywords"]');
      if (kw) kw.remove();
    };
  }, [title, description, path, image, type, noindex, ld, keywords]);
}

export const breadcrumbLd = (items) => ({
  "@type": "BreadcrumbList",
  itemListElement: items.map(([name, path], i) => ({
    "@type": "ListItem",
    position: i + 1,
    name,
    item: window.location.origin + path,
  })),
});
